
import { Component, Vue, Prop } from "vue-property-decorator";
import { plainToInstance } from "class-transformer";

import unit_routes from "@/api/routes/units";

import { phases } from "@/consts";

import Upload from "@/components/Upload.vue";
import ImageView from "@/components/ImageView.vue";
import VideoView from "@/components/VideoView.vue";
import CAudioView from "@/components/audioView.vue";
import PdfView from "@/components/PdfView.vue";
import CFileDownload from "@/components/FileDownload.vue";

import RelationVersion from "@/models/relation/version";
import UnitVersion, { EUnitableType } from "@/models/unit/unit_version";
import PracticalVersion from "@/models/unit/unitable/practical/version";
import UnitUnit from "@/models/unit/unit";

@Component({
  name: "CProgramMaterialPractical",
  components: {
    Upload,
    CFileDownload,
    ImageView,
    VideoView,
    CAudioView,
    PdfView
  }
})
export default class CProgramMaterialPractical extends Vue {
  @Prop({ required: true }) program_id!: string;
  @Prop({ required: true }) relation!: RelationVersion;
  @Prop({ required: false, default: false }) public disabled!: boolean;

  public phases = phases.slice(1, 5);

  public acceptFiles: string[] = [
    "application/pdf",
    "image/jpeg",
    "image/bmp",
    "image/png",
    "video/mp4",
    "audio/mpeg",
    "audio/wav",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // docx
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // xlsx
    "application/vnd.ms-excel.sheet.macroenabled.12", // xlsm MacOS|Linux
    "application/vnd.ms-excel.sheet.macroEnabled.12", //xlsm Win
    "application/vnd.openxmlformats-officedocument.presentationml.presentation", // pptx
    "application/msword", // doc
    "application/vnd.ms-excel", // xlx
    "application/vnd.ms-powerpoint", // ppt
    "application/vnd.oasis.opendocument.text", // odt
    "application/vnd.oasis.opendocument.spreadsheet", // ods
    "application/vnd.oasis.opendocument.presentation", // odp
    "application/rtf" // rtf
  ];

  public unit_version: UnitVersion | null = null;
  public edit_errors: string | null = null;

  protected async created() {
    await this.loadPractical();
  }

  public changeFormat(type: string | null) {
    (this.unit_version!.unitable as PracticalVersion).file_type = type
      ? type
      : (this.unit_version!.unitable as PracticalVersion)!
          .url!.split(".")
          .pop()!;
  }

  public unitable() {
    return this.unit_version?.unitable as PracticalVersion;
  }

  private async loadPractical() {
    if (this.relation.unit_version_id) {
      return this.$api
        .get(unit_routes.version(this.relation.unit_version_id))
        .then(({ data: res }: { data: UnitVersion }) => {
          this.unit_version = plainToInstance(UnitVersion, res);
        });
    } else {
      this.unit_version = new UnitVersion({
        relation_version: this.relation,
        unit: new UnitUnit({ is_template: false }),
        unitable: new PracticalVersion(),
        unitable_type: EUnitableType["Practical::Version"]
      });

      this.unit_version!.title = "Практическое задание";
    }
  }

  public async createPractical() {
    return this.$api
      .post(unit_routes.versions, {
        ...this.unit_version,
        ...{ relation: { program_id: this.program_id } }
      })
      .then(({ data: res }: { data: RelationVersion }) => {
        this.$emit("relationCreated", res);
      })
      .catch(({ response: res }) => {
        this.edit_errors = res.data.error;
      });
  }

  public async updatePractical() {
    if (
      !window.confirm(
        "Вы уверены, что хотите сохранить новую редакцию материала?"
      )
    ) {
      return;
    }

    return this.$api
      .put(unit_routes.version(this.unit_version!.id), {
        ...this.unit_version,
        ...{
          relation_version: { id: this.relation.id, level: this.relation.level }
        }
      })
      .then(({ data: res }: { data: RelationVersion }) => {
        this.$emit("relationUpdated", res);
      })
      .catch(({ response: res }) => {
        this.edit_errors = res.data.error;
      });
  }
}
